var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-main common" },
    [
      _c(
        "a-tabs",
        [
          _c("a-tab-pane", { attrs: { tab: "开票信息" } }, [
            _c(
              "div",
              { staticClass: "common-form-inline" },
              [
                _c(
                  "a-form-model",
                  {
                    ref: "oiForm",
                    attrs: {
                      model: _vm.oiInfo,
                      rules: _vm.oiRules,
                      "label-col": _vm.labelCol,
                      "wrapper-col": _vm.wrapperCol
                    }
                  },
                  [
                    _c(
                      "a-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: "企业名称",
                                  prop: "customerName"
                                }
                              },
                              [
                                _c("a-input", {
                                  attrs: {
                                    maxLength: 30,
                                    disabled: _vm.isDetail
                                  },
                                  model: {
                                    value: _vm.oiInfo.customerName,
                                    callback: function($$v) {
                                      _vm.$set(_vm.oiInfo, "customerName", $$v)
                                    },
                                    expression: "oiInfo.customerName"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "form-input-len" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.oiInfo.customerName
                                        ? _vm.oiInfo.customerName.length
                                        : 0
                                    ) + "/30"
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: "纳税人识别号",
                                  prop: "taxpayerIdentityNumber"
                                }
                              },
                              [
                                _c("a-input", {
                                  attrs: {
                                    maxLength: 20,
                                    disabled: _vm.isDetail
                                  },
                                  model: {
                                    value: _vm.oiInfo.taxpayerIdentityNumber,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.oiInfo,
                                        "taxpayerIdentityNumber",
                                        $$v
                                      )
                                    },
                                    expression: "oiInfo.taxpayerIdentityNumber"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "form-input-len" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.oiInfo.taxpayerIdentityNumber
                                        ? _vm.oiInfo.taxpayerIdentityNumber
                                            .length
                                        : 0
                                    ) + "/20"
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: "地址",
                                  prop: "customerAddress"
                                }
                              },
                              [
                                _c("a-input", {
                                  attrs: {
                                    maxLength: 50,
                                    disabled: _vm.isDetail
                                  },
                                  model: {
                                    value: _vm.oiInfo.customerAddress,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.oiInfo,
                                        "customerAddress",
                                        $$v
                                      )
                                    },
                                    expression: "oiInfo.customerAddress"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "form-input-len" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.oiInfo.customerAddress
                                        ? _vm.oiInfo.customerAddress.length
                                        : 0
                                    ) + "/50"
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: { label: "电话", prop: "customerPhone" }
                              },
                              [
                                _c("a-input", {
                                  attrs: {
                                    maxLength: 20,
                                    disabled: _vm.isDetail
                                  },
                                  model: {
                                    value: _vm.oiInfo.customerPhone,
                                    callback: function($$v) {
                                      _vm.$set(_vm.oiInfo, "customerPhone", $$v)
                                    },
                                    expression: "oiInfo.customerPhone"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "form-input-len" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.oiInfo.customerPhone
                                        ? _vm.oiInfo.customerPhone.length
                                        : 0
                                    ) + "/20"
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: { label: "开户行", prop: "depositBank" }
                              },
                              [
                                _c("a-input", {
                                  attrs: {
                                    maxLength: 30,
                                    disabled: _vm.isDetail
                                  },
                                  model: {
                                    value: _vm.oiInfo.depositBank,
                                    callback: function($$v) {
                                      _vm.$set(_vm.oiInfo, "depositBank", $$v)
                                    },
                                    expression: "oiInfo.depositBank"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "form-input-len" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.oiInfo.depositBank
                                        ? _vm.oiInfo.depositBank.length
                                        : 0
                                    ) + "/30"
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: { label: "账号", prop: "accountNumber" }
                              },
                              [
                                _c("a-input", {
                                  attrs: {
                                    maxLength: 20,
                                    disabled: _vm.isDetail
                                  },
                                  model: {
                                    value: _vm.oiInfo.accountNumber,
                                    callback: function($$v) {
                                      _vm.$set(_vm.oiInfo, "accountNumber", $$v)
                                    },
                                    expression: "oiInfo.accountNumber"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "form-input-len" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.oiInfo.accountNumber
                                        ? _vm.oiInfo.accountNumber.length
                                        : 0
                                    ) + "/20"
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-tabs",
        [
          _c(
            "a-tab-pane",
            {
              staticStyle: { "margin-bottom": "30px" },
              attrs: { tab: "接收信息" }
            },
            [
              _c(
                "div",
                { staticClass: "common-form-inline" },
                [
                  _c(
                    "a-form-model",
                    {
                      ref: "rcvrForm",
                      attrs: {
                        model: _vm.oiInfo,
                        rules: _vm.oiRules,
                        "label-col": _vm.labelCol,
                        "wrapper-col": _vm.wrapperCol
                      }
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "收件人",
                                    prop: "receiverName"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      maxLength: 10,
                                      disabled: _vm.isDetail
                                    },
                                    model: {
                                      value: _vm.oiInfo.receiverName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.oiInfo,
                                          "receiverName",
                                          $$v
                                        )
                                      },
                                      expression: "oiInfo.receiverName"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "form-input-len" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.oiInfo.receiverName
                                            ? _vm.oiInfo.receiverName.length
                                            : 0
                                        ) + "/10"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: { label: "电话", prop: "receivePhone" }
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      maxLength: 20,
                                      disabled: _vm.isDetail
                                    },
                                    model: {
                                      value: _vm.oiInfo.receivePhone,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.oiInfo,
                                          "receivePhone",
                                          $$v
                                        )
                                      },
                                      expression: "oiInfo.receivePhone"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "form-input-len" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.oiInfo.receivePhone
                                            ? _vm.oiInfo.receivePhone.length
                                            : 0
                                        ) + "/20"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "地址",
                                    prop: "receiverAddress"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      maxLength: 50,
                                      disabled: _vm.isDetail
                                    },
                                    model: {
                                      value: _vm.oiInfo.receiverAddress,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.oiInfo,
                                          "receiverAddress",
                                          $$v
                                        )
                                      },
                                      expression: "oiInfo.receiverAddress"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "form-input-len" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.oiInfo.receiverAddress
                                            ? _vm.oiInfo.receiverAddress.length
                                            : 0
                                        ) + "/50"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "电子发票接收邮箱",
                                    prop: "einvoiceReceiveMail"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      maxLength: 20,
                                      disabled: _vm.isDetail
                                    },
                                    model: {
                                      value: _vm.oiInfo.einvoiceReceiveMail,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.oiInfo,
                                          "einvoiceReceiveMail",
                                          $$v
                                        )
                                      },
                                      expression: "oiInfo.einvoiceReceiveMail"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "form-input-len" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.oiInfo.einvoiceReceiveMail
                                            ? _vm.oiInfo.einvoiceReceiveMail
                                                .length
                                            : 0
                                        ) + "/20"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spaceCenter model-footer-btns" },
        [
          _c(
            "a-button",
            { staticClass: "btn-blue-line btn-big", on: { click: _vm.goback } },
            [_vm._v("返回")]
          ),
          _vm._v(" "),
          !_vm.isDetail
            ? _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  attrs: { type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v("保存")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e97b03c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e97b03c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/security/vertify/updateoi.vue
// module id = x9q0
// module chunks = 1